<template>
  <div>
    <file-pond
      class="hidden md:block"
      ref="pond"
      label-idle="Drop photos here, paste or click to browse"
      accepted-file-types="image/jpeg, image/png"
      :allow-multiple="true"
      :server="server"
      @processfile="processFile"
      @removefile="removeFile"
    />

    <file-pond
      class="block md:hidden"
      ref="pond"
      label-idle="Tap here to take a photo or to choose an existing image"
      accepted-file-types="image/jpeg, image/png"
      :allow-multiple="true"
      :server="server"
      @processfile="processFile"
      @removefile="removeFile"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata'
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileMetadata
)

export default {
  components: {
    FilePond,
  },
  props: {
    list: Array,
  },
  data() {
    return {
      server: {
        url: '/upload/api',
        process: '/process',
        // process: (fieldName, file, metadata, load) => {
        //   // simulates uploading a file
        //   setTimeout(() => {
        //     load(Date.now())
        //   }, 500)
        // },
        revert: '/process',
      },
    }
  },
  methods: {
    processFile(error, file) {
      if (!error) {
        this.list.push({
          id: file.id,
          serverId: file.serverId,
          name: file.filename,
          size: file.fileSize,
          type: file.fileType,
        })
      }
    },
    removeFile(error, file) {
      if (!error) {
        const photoIndex = this.list.findIndex(i => i.id === file.id)
        if (photoIndex > -1) {
          let list = this.list
          list.splice(photoIndex, 1)
          this.$emit('update:list', list)
        }
      }
    },
  },
}
</script>